<!-- SettingsIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <!-- Center circle -->
    <circle 
      cx="12" 
      cy="12" 
      r="3" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Gear teeth - 8 spokes -->
    <path 
      d="M12 2V6" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M12 18V22" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M22 12H18" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M6 12H2" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M19.778 4.222L17.071 6.929" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M6.929 17.071L4.222 19.778" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M19.778 19.778L17.071 17.071" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M6.929 6.929L4.222 4.222" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>